module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"privacy-policy":"Privacy & Policy","terms-of-service":"Terms of Service"},"pt-BR":{"privacy-policy":"Políticas de Privacidade","terms-of-service":"Termos de Serviço"}}')
  delete Component.options._Ctor
}
